module.exports = __webpack_public_path__ + "img/1.f1779da8.png";